import React from 'react';
import { Grid } from '@cp/ds/src/components/grid';
import { CareerTile, coreCareerApi } from '@cp/entities/career';
import { useTrackMount } from 'src/shared/tracking';
import { registrationCareerModal } from '../../lib';
import { ClientRegistrationStepProps } from './model';

export const StepCareer = (props: ClientRegistrationStepProps) => {
  useTrackMount(registrationCareerModal);
  const clickHandler = (mainCareerId: number) => {
    return props.onSubmit({ mainCareerId });
  };
  const { data: careerDictionary } = coreCareerApi.endpoints.getCareers.useQuery();
  const items = React.useMemo(
    () =>
      Object.entries({ ...careerDictionary /*, ...newCareersDict*/ }).map(
        ([careerId, careerViewModel]) => [Number(careerId), careerViewModel] as const,
      ),
    [careerDictionary],
  );
  return (
    <Grid container spacing={1} sx={{ flexWrap: 'wrap', px: { xs: 2.5, md: 0 } }}>
      {items.map(([careerId, careerViewModel]) => (
        <Grid key={careerId} size={{ xs: 6 }} sx={{ display: 'flex' }}>
          <CareerTile
            careerId={careerId}
            label={careerViewModel.translation.namePlural}
            onClick={'isActive' in careerViewModel && !careerViewModel.isActive ? undefined : () => clickHandler(careerId)}
          />
        </Grid>
      ))}
    </Grid>
  );
};
